<style lang="less" scoped>
.title-div {
    font-weight: 600;
    margin: 20px 0 10px;
    font-size: 26px;
    // flex-grow: 1;
    color: #000;
}

.history {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #4182eb;
    line-height: 20px;
    height: 25px;
    margin-top: 35px;
    margin-left: 15px;
}

.custInfo_container {
    width: 100%;
    margin: 20px 10px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    display: flex;

    .cust-item {
        width: 25%;
    }
}

.el-col {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    margin: 10px 0;

    >div:first-of-type {
        // width: 120px;
        text-align: left;
        font-size: 14px;
        font-weight: 400;
    }

    >div:last-of-type {
        font-size: 14px;
        min-width: 160px;
        text-align: right;
    }
}

// .cust-detail-item {
//   // t-w
// }
.page-action-btns {
    margin-bottom: 10px;
}

.cust-mes {
    margin: 0px 0px 14px 18px;
}

.top-title-div {
    font-size: 15px;
    margin-left: 10px;
}

.red-tip {
    color: #f56c6c;
    font-size: 12px;
    margin-left: 100px;
}

.detail-btn {
    height: 32px;
    margin-left: 45px;
    margin-top: 10px;
}

.account_item {
    width: 437px;
    height: 101px;
    background: #4182eb;
    border-radius: 22px;
    color: #fff;
    padding: 10px 20px;


    .amount_con {
        // flex-grow: 1;
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
    }

}
</style>

<template>
    <div class="detail-content-div">
        <div class="title-div">

            <el-row :gutter="10" style="margin-bottom: 16px;">
                <el-col :span="6">
                    <p class="margin-bottom-5 font-14">设备编号：</p>
                    <el-select v-model="queryInfo.pileCode" size="small" filterable class="full-width"
                        placeholder="请选择">
                        <el-option v-for="(item, index) in pileList" :key="index" :label="item" :value="item" />
                    </el-select>
                </el-col>
            </el-row>

            <el-tabs v-model="activeName" @tab-click="handleClick" type="card">
                <el-tab-pane label="共享充电订单" name="first">

                    <div class="flex align-items" style="justify-content: space-between;">
                        <div class="account_item">
                            <div class="amount_con">
                                <p>累计数据</p>
                                <div class="flex" style="justify-content: space-between;margin-top: 20px;">
                                    <div>
                                        <p>{{ chargeCount.ownerProfitCount }}</p>
                                        <p>共享总收益（元）</p>
                                    </div>
                                    <div>
                                        <p>{{ chargeCount.chargeValCount }}</p>
                                        <p>充电总电量（度）</p>
                                    </div>
                                    <div>
                                        <p>{{ chargeCount.chargeUserCount }}</p>
                                        <p>共享总用户（数）</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div ref="chartAF" style="width: 300px; height: 200px"></div>
                        </div>
                        <div>
                            <div ref="chartAG" style="width: 300px; height: 200px"></div>
                        </div>
                        <div>
                            <div ref="chartAH" style="width: 300px; height: 200px"></div>
                        </div>
                    </div>
                    <el-table class="el-table" :data="tableData" border style="width: 100%;margin:20px auto"
                        :cell-style="{ 'text-align': 'center' }">
                        <el-table-column align="center" prop="orderNo" label="共享充电订单ID" width="260" />
                        <el-table-column align="center" prop="reserveOrderNo" label="关联预约订单ID" width="240" />
                        <el-table-column align="center" prop="deviceTypeName" label="共享设备类型" width="200" />
                        <el-table-column align="center" prop="pileCode" label="充电设备编号/IME" width="240" />
                        <el-table-column align="center" prop="stationName" label="站点名称" width="240" />
                        <el-table-column align="center" prop="bindSourceName" label="充电业务归属" width="240" />
                        <el-table-column align="center" prop="custTypeName" label="充电用户账号类型" width="240" />
                        <el-table-column align="center" prop="shareStartTypeName" label="共享充电类型" width="240" />
                        <el-table-column align="center" prop="shareOrderStatusName" label="订单状态" width="240" />
                        <el-table-column align="center" prop="orderPropertyName" label="订单属性" width="240" />
                        <el-table-column align="center" prop="beginTime" label="开始时间" width="160" />
                        <el-table-column align="center" prop="endTime" label="结束时间" width="160" />
                        <el-table-column align="center" prop="chargeOverReason" label="结束方式" width="160" />
                        <el-table-column align="center" prop="chargeMin" label="充电时长" width="160" />
                        <el-table-column align="center" prop="chargeVal" label="充电电量" width="160" />
                        <el-table-column align="center" prop="prePayFee" label="充电预付费用（元）" width="160" />
                        <el-table-column align="center" prop="actPayFee" label="充电实付费用（元）" width="160" />
                        <el-table-column align="center" prop="servFee" label="平台服务费（元）" width="160" />
                        <el-table-column align="center" prop="preAmtPayFee" label="已退预付费用（元）" width="160" />
                        <el-table-column align="center" prop="actAmtPayFee" label="已退实收费用（元）" width="160" />
                        <el-table-column align="center" prop="transStatusName" label="预付退款状态" width="160" />
                        <el-table-column align="center" prop="transFinishedTime" label="预付退款完成时间" width="160" />
                        <el-table-column align="center" prop="lastModifiedByName" label="更新人" width="140" />
                        <el-table-column align="center" prop="lastModifiedWhen" label="更新时间" width="180" />
                        <el-table-column align="center" prop="remark" label="备注" width="200" />
                    </el-table>
                    <!-- 分页 -->
                    <div class="list-pagination">
                        <ZD-pagination :pagination="pagination" v-on:pageUpdate="getShareChargeData" />
                    </div>
                </el-tab-pane>
                <el-tab-pane label="共享预约订单" name="second">
                    <el-table class="el-table" :data="tableData" border style="width: 100%;margin:20px auto"
                        :cell-style="{ 'text-align': 'center' }">
                        <el-table-column align="center" prop="reserveOrderNo" label="共享预约订单ID" :min-width="280" />
                        <el-table-column align="center" prop="orderNo" label="关联充电订单ID" :min-width="280" />
                        <el-table-column align="center" prop="reserveTypeName" label="共享预约类型" :min-width="280" />
                        <el-table-column align="center" prop="deviceCode" label="预约设备编号/IMEI" :min-width="200" />
                        <el-table-column align="center" prop="custMobile" label="设备所属用户手机号" :min-width="180" />
                        <el-table-column align="center" prop="custTypeName" label="充电用户账号类型" :min-width="150" />
                        <el-table-column align="center" prop="custPhone" label="下单用户手机号" :min-width="150" />
                        <el-table-column align="center" prop="stationName" label="站点名称" :min-width="150" />
                        <el-table-column align="center" prop="stationAddr" label="站点地址" :min-width="320" />
                        <el-table-column align="center" prop="bindSourceName" label="预约业务归属" :min-width="200" />
                        <el-table-column align="center" prop="deviceTypeName" label="共享设备类型" :min-width="200" />
                        <el-table-column align="center" prop="orderStatusName" label="订单状态" :min-width="200" />
                        <el-table-column align="center" prop="localReserveBeginTime" label="当前预约开始时间" :min-width="200" />
                        <el-table-column align="center" prop="localReserveEndTime" label="当前预约结束时间" :min-width="200" />
                        <el-table-column align="center" prop="reserveTime" label="下单时间" :min-width="200" />
                        <el-table-column align="center" prop="updateCount" label="修改次数" :min-width="200" />
                        <el-table-column align="center" prop="beforeReserveBeginTime" label="原始预约开始时间" :min-width="200" />
                        <el-table-column align="center" prop="beforeReserveEndTime" label="原始预约结束时间" :min-width="200" />
                        <el-table-column align="center" prop="remark" label="备注" :min-width="200" />
                        <el-table-column align="center" prop="lastModifiedWhen" label="更新时间" :min-width="200" />
                    </el-table>
                    <!-- 分页 -->
                    <div class="list-pagination">
                        <ZD-pagination :pagination="pagination" v-on:pageUpdate="getShareAppointmentData" />
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
import pageConfig from '../operationConfiguration/couponManagement/couponAllocation/page-config';
import * as echarts from 'echarts';
export default {
    data() {
        return {
            pageConfig: pageConfig, // 页面配置
            tableData: [], // 表格数据
            activeName: "first",
            pagination: pageConfig.pagination,
            pageTitle: "客户详情",
            pileList: [], // 桩数据项
            // 默认值设置
            custInfo: {},
            queryInfo: {}, // 默认内容
            chargeCount: {},
        };
    },
    methods: {
        init() {
            let _ = this;
            if (_.$store.state.custObj) {
                _.custInfo = _.$store.state.custObj;
                // _.queryInfo.userPhone = _.custInfo.mobile;
                _.pileList = _.custInfo.pileCodes || [];
                _.queryInfo.pileCode = _.custInfo.pileCodes.length > 0 ? _.custInfo.pileCodes[0] : '';
                _.initEcharts()
                _.handleClick('first')
            }
        },

        handleClick(val) {
            let _ = this
            _.activeName = val.name || val;
            _.tableData = [];
            if (_.activeName == "first") {
                _.getShareChargeData(_.pagination, true)
            }
            if (_.activeName == "second") {
                _.getShareAppointmentData(_.pagination, true)
            }
        },

        initEcharts() {
            let _ = this;
            const params = {
                deviceCode: _.custInfo.pileCode,
                deviceType: _.custInfo.deviceType
            }
            _.$H.post(_, _.$A.cust.getLineChart, params).then(res => {

                const list = res.data.data.totalLineChart || []

                let dateList = [];
                let dataAH = [];
                let dataAF = [];
                let dataAG = [];

                let chartAH = this.$echarts.init(this.$refs.chartAH);
                let chartAF = this.$echarts.init(this.$refs.chartAF);
                let chartAG = this.$echarts.init(this.$refs.chartAG);

                if (list.length > 0) {

                    list.forEach((li, index) => {
                        dateList.push(list[index].xAxis)
                        dataAH.push(list[index].ownerProfitCount)
                        dataAF.push(list[index].chargeValCount)
                        dataAG.push(list[index].chargeUserCount)
                    })

                }

                let optionAH = {
                    title: {
                        text: '累计共享收益（元）',
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            label: {
                                backgroundColor: '#6a7985'
                            }
                        }
                    },
                    grid: {
                        bottom: '10%',
                        left: '0%',
                        right: '0%'
                    },
                    xAxis: [
                        {
                            type: 'category',
                            boundaryGap: false,
                            data: dateList,
                        }
                    ],
                    yAxis: [
                        {
                            type: 'value'
                        }
                    ],
                    series: [
                        {
                            type: 'line',
                            areaStyle: {
                                opacity: 0.8,
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                    {
                                        offset: 0,
                                        color: 'rgba(235,210,125,.9)'
                                    },
                                    {
                                        offset: 1,
                                        color: 'rgba(235,210,125,.1)'
                                    }
                                ])
                            },
                            lineStyle: {
                                color: '#ebd27d'
                            },
                            itemStyle: {
                                color: '#ebd27d'
                            },
                            emphasis: {
                                focus: 'series'
                            },
                            smooth: true,
                            data: dataAH || [],
                        },
                    ]
                }
                chartAH.setOption(optionAH);

                let optionAF = {
                    title: {
                        text: '累计共享电量（度）'
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            label: {
                                backgroundColor: '#6a7985'
                            }
                        }
                    },
                    grid: {
                        bottom: '10%',
                        left: '0%',
                        right: '0%'
                    },
                    xAxis: [
                        {
                            type: 'category',
                            boundaryGap: false,
                            data: dateList,
                        }
                    ],
                    yAxis: [
                        {
                            type: 'value'
                        }
                    ],
                    series: [
                        {
                            type: 'line',
                            areaStyle: {
                                opacity: 0.8,
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                    {
                                        offset: 0,
                                        color: 'rgba(235,210,125,.9)'
                                    },
                                    {
                                        offset: 1,
                                        color: 'rgba(235,210,125,.1)'
                                    }
                                ])
                            },
                            lineStyle: {
                                color: '#ebd27d'
                            },
                            itemStyle: {
                                color: '#ebd27d'
                            },
                            emphasis: {
                                focus: 'series'
                            },
                            smooth: true,
                            data: dataAF || [],
                        },
                    ]
                }
                chartAF.setOption(optionAF);

                let optionAG = {
                    title: {
                        text: '累计共享用户（数）'
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            label: {
                                backgroundColor: '#6a7985'
                            }
                        }
                    },
                    grid: {
                        bottom: '10%',
                        left: '0%',
                        right: '0%'
                    },
                    xAxis: [
                        {
                            type: 'category',
                            boundaryGap: false,
                            data: dateList,
                        }
                    ],
                    yAxis: [
                        {
                            type: 'value'
                        }
                    ],
                    series: [
                        {
                            type: 'line',
                            areaStyle: {
                                opacity: 0.8,
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                    {
                                        offset: 0,
                                        color: 'rgba(235,210,125,.9)'
                                    },
                                    {
                                        offset: 1,
                                        color: 'rgba(235,210,125,.1)'
                                    }
                                ])
                            },
                            lineStyle: {
                                color: '#ebd27d'
                            },
                            itemStyle: {
                                color: '#ebd27d'
                            },
                            emphasis: {
                                focus: 'series'
                            },
                            smooth: true,
                            data: dataAG,
                        },
                    ]
                }
                chartAG.setOption(optionAG);

                setTimeout(() => {
                    window.addEventListener("resize", function () {
                        chartAF.resize();
                        chartAG.resize();
                        chartAH.resize();
                    });
                }, 500)

            })

        },

        // 获取共享充电订单表格数据
        getShareChargeData(pagination, reload = false) {
            let _ = this;
            _.$U.showLoading(_);
            _.queryInfo.pageNum = pagination.current - 1;
            if (reload) {
                _.pagination.current = 1;
                _.queryInfo.pageNum = 0;
            }
            _.queryInfo.pageSize = pagination.pageSize;
            _.queryInfo.corpNo = _.$store.state.corpNo;

            _.$U.showLoading(_);

            const params = {
                deviceCode: _.queryInfo.pileCode,
                deviceType: _.custInfo.deviceType
            }
            _.$H.post(_, _.$A.cust.getCount, params).then(res => {
                _.chargeCount = res.data.data.total || {};
            })

            _.$H.post(_, _.$A.cust.getChargePileOrder, _.queryInfo).then((res) => {
                _.tableData = res.data.data.content || [];
                _.pagination.total = res.data.data.totalElements || 0;
                _.$U.hideLoading(_);
            });


        },
        // 获取共享预约表格数据
        getShareAppointmentData(pagination, reload = false) {
            let _ = this;
            _.$U.showLoading(_);
            _.queryInfo.pageNum = pagination.current - 1;
            if (reload) {
                _.pagination.current = 1;
                _.queryInfo.pageNum = 0;
            }
            _.queryInfo.pageSize = pagination.pageSize;
            _.queryInfo.corpNo = _.$store.state.corpNo;
            _.$U.showLoading(_);
            _.$H.post(_, _.$A.cust.getSharePileOrder, _.queryInfo).then((res) => {
                _.tableData = res.data.data.content || [];
                _.pagination.total = res.data.data.totalElements || 0;
                _.$U.hideLoading(_);
            });
        },

        resetQuery() {
            this.queryInfo = {
                searchKey: undefined,
            };
            this.getListData(this.pagination, true);
        },
    },
    mounted() {
        this.init();
    },
};
</script>
